import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../store/base.graphql";

export const CHANGE_PASSWORD = gql`
mutation ChangePassword($input: ChangePasswordInputObject!) {
  changePassword(input: $input) {
    ${baseResponseGraphqlField}
  }
}
`
